import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

const BORDER_RADIUS = '3px';

export const ButtonGroup: FC<{
  buttonGroup: Array<{label: string; value: string}>;
  dataTestId?: string;
  onButtonClick: (buttonValue: string) => void;
  selectedButtonGroupValue?: string;
}> = ({
  buttonGroup,
  dataTestId = 'buttonGroup',
  onButtonClick,
  selectedButtonGroupValue,
  ...props
}) => {
  return (
    <Wrapper data-testid={dataTestId} {...props}>
      {buttonGroup.map((button, buttonIndex) => {
        const active = button.value === selectedButtonGroupValue;
        const buttonId = `${dataTestId}_button_${button.value}${
          active ? '_selected' : ''
        }`;

        return (
          <Button
            active={active}
            data-testid={buttonId}
            first={buttonIndex === 0}
            flex={1 / (buttonGroup.length ?? 1)}
            key={buttonId}
            last={buttonIndex === buttonGroup.length - 1}
            onClick={() => onButtonClick(button.value)}
          >
            {button.label}
          </Button>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  height: 2rem;
  width: 100%;
  border-radius: ${BORDER_RADIUS};
  border: 1px solid ${COLORS.Grey3};
`;

const Button = styled.button<{
  active?: boolean;
  first: boolean;
  flex: number;
  last: boolean;
}>`
  align-items: center;
  background-color: ${({active}) => (active ? COLORS.Black : 'transparent')};
  color: ${({active}) => (active ? COLORS.White : COLORS.Black)};
  border: none;
  border-radius: ${BORDER_RADIUS};
  display: flex;
  flex: ${({flex}) => flex};
  font-size: inherit;
  font-weight: inherit;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  transition: 0.15s;

  &:focus {
    outline: none;
  }
`;
